export const APP_FILE_VIEW_OPPORTUNITIES_ROUTE = "/opportunites";
export const APP_FILE_MANAGE_OPPORTUNITIES_ROUTE = "/opportunites/manage";
export const APP_FILE_MANAGE_OPPORTUNITIES_ID_ROUTE = "/opportunites/manage/:leadId";